import { post } from './api'

export function getappinfo (data) {
  return post(
    'https://game.hotplaygames.com/complianceh5/getappinfo',
    data
  )
}

export function getallapp (data) {
  return post(
    'https://game.hotplaygames.com/complianceh5/getallapp',
    data
  )
}

export function discountlist (data) {
  return post(
    'https://game.hotplaygames.com/complianceh5/discountlist',
    data
  )
}

export function query (data) {
  return post(
    'https://game.hotplaygames.com/complianceh5/query',
    data
  )
}


// WEBPACK FOOTER //
// ./src/util/ourplay.js